// src/App.js (Versão final com todas as rotas, incluindo as de redefinição de senha)

import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

// Imports de todos os nossos componentes de página
import LandingPage from './components/LandingPage';
import Login from './components/Login';
import Register from './components/Register';
import VerifyEmail from './components/VerifyEmail';
import ForgotPasswordPage from './components/ForgotPasswordPage';
import ResetPasswordPage from './components/ResetPasswordPage';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import TransactionsPage from './components/TransactionsPage';
import MonthlyReport from './components/MonthlyReport';
import ProfilePage from './components/ProfilePage';
import CategoryPage from './components/CategoryPage';
import BudgetsPage from './components/BudgetsPage';
import AdminPage from './components/AdminPage';
import WhatsNewModal from './components/WhatsNewModal';
import CreditCardsPage from './components/CreditCardsPage';
import CreditCardDetailsPage from './components/CreditCardDetailsPage';
import IncomeTaxPage from './components/IncomeTaxPage';
import SettingsPage from './components/SettingsPage';

import SubscriptionPage from './components/SubscriptionPage';
import NotFoundPage from './components/NotFoundPage';

function PrivateRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <Router>
      <Toaster position="top-right" toastOptions={{ /* ... */ }} />

      <Routes>
        {/* --- ROTAS PÚBLICAS --- */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verify" element={<VerifyEmail />} />
        {/* AS ROTAS QUE FALTAVAM ESTÃO AQUI: */}
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password/:token" element={<ResetPasswordPage />} />

        {/* --- ROTAS PRIVADAS (DENTRO DA APLICAÇÃO) --- */}
        <Route path="/app" element={<PrivateRoute><Layout /></PrivateRoute>}>
          <Route index element={<Navigate to="dashboard" />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="transactions" element={<TransactionsPage />} />
          <Route path="reports" element={<MonthlyReport />} />
          <Route path="budgets" element={<BudgetsPage />} />
          <Route path="settings" element={<SettingsPage />}>
            <Route index element={<Navigate to="profile" />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="categories" element={<CategoryPage />} />
            <Route path="admin" element={<AdminPage />} />
          </Route>
          <Route path="credit-cards" element={<CreditCardsPage />} />
          <Route path="credit-cards/:id" element={<CreditCardDetailsPage />} />
          <Route path="income-tax" element={<IncomeTaxPage />} />
          <Route path="subscription" element={<SubscriptionPage />} />
        </Route>

        {/* Página 404 customizada */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App;